<template>
  <div id="app">
    <!-- 标题 -->
    <header class="header">💎 六小福珠宝</header>

    <!-- 时间栏 -->
    <div class="time-bar">
      <span class="time-icon">⏰</span>
      <span class="time-text">{{ currentTime }}</span>
      <span class="status" :class="isOpen ? 'open' : 'close'">
        {{ isOpen ? '开盘' : '停盘' }}
      </span>
    </div>

    <!-- 表头 -->
    <div class="table-header">
      <div class="col">商品</div>
      <div class="col">回购</div>
      <div class="col">销售</div>
      <div class="col">高 / 低</div>
    </div>

    <!-- 行情 -->
    <div v-if="quotes.length">
      <div
        v-for="quote in quotes"
        :key="quote.id"
        class="table-row"
      >
        <div class="col name">{{ quote.name }}</div>

        <div class="col" :class="getChangeColor(quote, 'l')">
          {{ formatNumber(quote.l) }}
        </div>

        <div class="col" :class="getChangeColor(quote, 'h')">
          {{ formatNumber(quote.h) }}
        </div>

        <div class="col highlow">
          <div class="high red">{{ formatNumber(quote.zh) }}</div>
          <div class="low green">{{ formatNumber(quote.zl) }}</div>
        </div>
      </div>

      <div class="quote-note">
        ⚠️ 行情数据来源于网络，仅供参考
      </div>
    </div>

    <div v-else class="loading">📡 数据加载中...</div>

    <!-- 底部 -->
  <footer class="footer" v-if="shop">
    <div>

      电话微信：{{ shop.mobile }}
    </div>
    <div>总店地址：{{ shop.address }}</div>
  </footer>

  </div>
</template>

<script>
export default {
  name: "App",

  data() {
    return {
      currentTime: "",

      quotes: [],
      shop: null,

      // 行情缓存
      displayPriceMap: {},

      // 自动开盘判断
      isOpen: false,
      lastPriceChangeTime: 0,
      OPEN_ACTIVE_WINDOW: 30000,

      // 定时器
      timeTimer: null,
      quoteTimer: null,
      priceTimer: null,
      openTimer: null,

      API_URL: "https://admin.xj566.top/api/api.php"
    };
  },

  methods: {
    /* ========= 工具 ========= */
    formatNumber(val) {
      const n = Number(val);
      return Number.isNaN(n) ? "--" : n.toFixed(2);
    },

    updateTime() {
      const d = new Date();
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const h = String(d.getHours()).padStart(2, "0");
      const i = String(d.getMinutes()).padStart(2, "0");
      const s = String(d.getSeconds()).padStart(2, "0");
      this.currentTime = `${y}-${m}-${day} ${h}:${i}:${s}`;
    },

    /* ========= 价格变化打点 ========= */
    markPriceChange(oldVal, newVal) {
      if (Number(oldVal).toFixed(2) !== Number(newVal).toFixed(2)) {
        this.lastPriceChangeTime = Date.now();
      }
    },

    /* ========= 拉行情 ========= */
    async fetchQuote() {
      try {
        const res = await fetch(this.API_URL);
        const json = await res.json();
        if (json.code !== 200 || !Array.isArray(json.data.list)) return;

        this.shop = json.data.address || null;

        json.data.list.forEach(item => {
          const id = String(item.id);
          const buy = Number(item.l);
          const sell = Number(item.h);

          if (!this.displayPriceMap[id]) {
            this.displayPriceMap[id] = {
              buy,
              sell,
              lastBuy: buy,
              lastSell: sell
            };
            this.lastPriceChangeTime = Date.now();
          } else {
            const cache = this.displayPriceMap[id];

            this.markPriceChange(cache.buy, buy);
            this.markPriceChange(cache.sell, sell);

            cache.lastBuy = cache.buy;
            cache.lastSell = cache.sell;
            cache.buy = buy;
            cache.sell = sell;
          }
        });

        this.quotes = json.data.list.map(item => ({
          ...item,
          l: this.displayPriceMap[item.id].buy,
          h: this.displayPriceMap[item.id].sell
        }));
      } catch (e) {
        console.error("行情异常", e);
      }
    },

    /* ========= 秒级波动 ========= */
    applyRandomFluctuation() {
      if (!this.isOpen) return;

      this.quotes = this.quotes.map(q => {
        const cache = this.displayPriceMap[q.id];
        if (!cache) return q;

        cache.lastBuy = cache.buy;
        cache.lastSell = cache.sell;

        const delta =
          (Math.random() * 0.06 + 0.01) * (Math.random() > 0.5 ? 1 : -1);

        const newBuy = cache.buy + delta;
        const newSell = cache.sell + delta;

        this.markPriceChange(cache.buy, newBuy);
        this.markPriceChange(cache.sell, newSell);

        cache.buy = newBuy;
        cache.sell = newSell;

        return {
          ...q,
          l: cache.buy,
          h: cache.sell
        };
      });
    },

    /* ========= 自动开盘判断 ========= */
    updateOpenStatus() {
      const now = Date.now();
      this.isOpen = now - this.lastPriceChangeTime <= this.OPEN_ACTIVE_WINDOW;
    },

    /* ========= 涨跌色 ========= */
    getChangeColor(quote, key) {
      const c = this.displayPriceMap[quote.id];
      if (!c) return "red";

      if (key === "l") {
        if (c.buy > c.lastBuy) return "red";
        if (c.buy < c.lastBuy) return "green";
      }

      if (key === "h") {
        if (c.sell > c.lastSell) return "red";
        if (c.sell < c.lastSell) return "green";
      }

      return "red";
    }
  },

  mounted() {
    this.updateTime();
    this.timeTimer = setInterval(this.updateTime, 1000);

    this.fetchQuote();
    this.quoteTimer = setInterval(this.fetchQuote, 3000);

    this.priceTimer = setInterval(this.applyRandomFluctuation, 1000);
    this.openTimer = setInterval(this.updateOpenStatus, 1000);
  },

  beforeUnmount() {
    clearInterval(this.timeTimer);
    clearInterval(this.quoteTimer);
    clearInterval(this.priceTimer);
    clearInterval(this.openTimer);
  }
};
</script>

<style>
:root {
  /* 🔥 footer 高度统一在这里改 */
  --footer-height: 90px;
}

#app {
  background: #121212;
  min-height: 100vh;
  color: #fff;
  font-family: "Microsoft YaHei", sans-serif;
  text-align: center;

  /* 🔥 关键：给 fixed footer 让位 */
  padding-bottom: var(--footer-height);
}

.header {
  font-size: 5vw;
  font-weight: bold;
  color: #f9c74f;
  padding: 2vh 0;
}

.time-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1e1f25;
  padding: 1vh;
  font-size: 2vw;
}

.status {
  margin-left: 1vw;
  font-weight: bold;
}

.status.open {
  color: #4caf50;
}

.status.close {
  color: #f94144;
}

.table-header,
.table-row {
  display: flex;
}

.table-header {
  background: #222;
  font-weight: bold;
}

.table-row {
  background: #1c1d22;
  margin-bottom: 1vh;
  border-radius: 6px;
}

.col {
  flex: 1;
  padding: 1vh 0;
  font-size: 3.8vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.name {
  color: #f9c74f;
}

.red {
  color: #ff4d4f;
  font-weight: bold;
}

.green {
  color: #4caf50;
  font-weight: bold;
}

.highlow {
  flex-direction: column;
}

.loading {
  margin-top: 6vh;
  font-size: 4.5vw;
  color: #aaa;
}

.quote-note {
  font-size: 1vw;
  color: #b15408;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: var(--footer-height);
  background: rgba(18, 18, 18, 0.95);
  padding: 1.5vh 0;
  font-size: 1.8vw;
  color: #ccc;
}
</style>
